<template>
	<div>
		<Layout :back="'/'" class="bg-primary " :navTransparent="true">
			<template slot="header">
				<h1>Recuperar contraseña</h1>
				<p>Te enviaremos un link a tu correo electrónico para cambiar tu contraseña</p>
			</template>

			<div class="main-container p-4">
				<div v-if="!sended">
					<FormulateForm ref="form" name="forgot" v-model="form" @submit="save">
						<FormulateInput label="Email" type="email" name="email" validation-name="Email" validation="required" />
					</FormulateForm>
				</div>
				<div v-if="sended" class="alert alert-warning text-center">
					Te hemos enviando un correo electrónico con un enlace para cambiar tu contraseña.
				</div>
			</div>
			<template slot="footer" v-if="!sended">
				<div class="w-100 p-2">
					<div class="btn btn-primary btn-lg btn-block" v-ripple @click="$formulate.submit('forgot')">
						<span v-if="saving">Enviando<i class="icon-loading"></i></span>
						<span v-else>Recuperar</span>
					</div>
				</div>
			</template>
		</Layout>
	</div>
</template>
<script>
import gql from 'graphql-tag'
import Layout from '@/components/layout/Layout'

export default {
	name: 'ForgotPassword',
	components: {
		Layout,
	},
	data() {
		return {
			form: {
				email: null,
			},
			sended: false,
			saving: false,
		}
	},
	methods: {
		save() {
			this.saving = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($email: String!) {
							sellerPasswordForgot(email: $email)
						}
					`,
					variables: {
						email: this.form.email,
					},
				})
				.then(({ data }) => {
					this.saving = false
					this.sended = true
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		},
	},
}
</script>

<style scoped>
h1 {
	font-size: 22pt;
	color: #fff;
}
.main-container {
	background-color: #fff;
	border-radius: 24px 0px 0px 0px;
}
</style>
